export default __webpack_public_path__ + "static/img_14-14a4b686ace95a2a2604befe38145e2c.png";